import { Article, ArticleTagType } from '@/redux/modules/article/article.types';

/**
 * Prefer brand, then category, as the keyword for related-items search.
 */
export const getArticleRelatedItemsKeyword = (article: Article | null): string | undefined => {
    const brand = article?.tags?.find((tag) => tag.type === ArticleTagType.Brand)?.value?.trim();
    if (brand) {
        return brand;
    }

    const category = article?.tags?.find((tag) => tag.type === ArticleTagType.Category)?.value?.trim();
    if (category) {
        return category;
    }

    return undefined;
};
